export default {
  toggleLoading(state, loading) {
    state.loading = loading;
  },
  setLogisticProviderEvents(state, logisticProviderEvents) {
    state.logisticProviderEvents = logisticProviderEvents;
  },
  setLogisticProviderForm(state, logisticProviderForm) {
    state.logisticProviderForm = logisticProviderForm;
  },
  setDefaultFilters(state, logistic_provider_id) {
    state.defaultFilters.logistic_provider_id = logistic_provider_id;
  },
};



// WEBPACK FOOTER //
// ./src/features/private/settings/pages/manage-events-order/pages/event-logistic-provider/store/mutations.js